<div class="typing-loader-overlay" [class.typing-loader-inline]="inline">
  <div class="typing-loader-container">
    <div class="typing-indicator">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</div>
